<div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
  <div class="d-flex flex-column">
    <h6 class="mb-0">Licenças de sistema do usuário</h6>
    <small class="text-muted">
      Cada licença libera os módulos de um sistema. Uma licença por sistema.
    </small>
  </div>

  <patron-button
    iconName="pi-refresh"
    color="primary"
    variant="outline"
    [disabled]="loading"
    [pTooltip]="'Recarregar'"
    (click)="load()">
  </patron-button>
</div>

@if (loading) {
  <div class="tab-loading">
    <patron-spinner></patron-spinner>
    <p class="mt-2 mb-0 text-muted">Carregando licenças do usuário...</p>
  </div>
} @else {
  @if (summary.length) {
    <section class="detail__section mb-3">
      <h6 class="detail__section-title text-muted">Saldo por sistema</h6>
      <div class="d-flex flex-wrap gap-2">
        @for (item of summary; track item.vendor_system_id) {
          <span
            [class]="item.available > 0 ? 'badge bg-success' : 'badge bg-secondary'"
            [pTooltip]="item.in_use + ' em uso agora'">
            {{ systemName(item) }} — {{ item.linked }} de {{ item.contracted }} vinculadas
          </span>
        }
      </div>
    </section>
  }

  @if (canWrite) {
    <div class="d-flex flex-wrap align-items-end gap-2 mb-3">
      <div>
        <label class="form-label mb-1 text-xs">Vincular licença de</label>
        <select
          class="form-select form-select-sm"
          [(ngModel)]="selectedSystemId"
          [disabled]="linking || !linkableSystems.length">
          <option value="">
            {{ linkableSystems.length ? 'Selecione o sistema' : 'Nenhum sistema com saldo' }}
          </option>
          @for (item of linkableSystems; track item.vendor_system_id) {
            <option [ngValue]="item.vendor_system_id">
              {{ systemName(item) }} ({{ item.available }} livre{{ item.available > 1 ? 's' : '' }})
            </option>
          }
        </select>
      </div>
      <patron-button
        iconName="pi-user-plus"
        color="primary"
        [disabled]="selectedSystemId === '' || linking"
        (click)="link()">
        <span class="ms-2">Vincular</span>
      </patron-button>
    </div>
  }

  @if (!licenses.length) {
    <div class="alert alert-info mb-0">
      {{ userName || 'Este usuário' }} não possui licença de sistema. Sem licença, ele não enxerga
      os módulos dos sistemas quando o controle de licenças estiver ligado para a empresa.
    </div>
  } @else {
    <patron-responsive-table
      [items]="licenses"
      [bodyTemplate]="licensesBody"
      [enableSelection]="false"
      [findOptions]="findOptions"
      [mobileSortable]="false">
      <ng-template #licensesBody let-item>
        <tr>
          <td>
            <patron-rt-column-title><strong>Sistema</strong></patron-rt-column-title>
            {{ systemName(item) }}
          </td>
          <td>
            <patron-rt-column-title><strong>Assento</strong></patron-rt-column-title>
            <span class="detail__value--mono">{{ item.number }}</span>
            @if (item.demo) {
              <span class="badge bg-info ms-1">Cortesia</span>
            }
          </td>
          <td>
            <patron-rt-column-title><strong>Apelido</strong></patron-rt-column-title>
            {{ item.alias || '—' }}
          </td>
          <td>
            <patron-rt-column-title><strong>Status</strong></patron-rt-column-title>
            <span [class]="statusClass(item)">{{ statusLabel(item) }}</span>
            @if (item.status === 'blocked' && item.blocked_reason) {
              <i class="pi pi-info-circle ms-1" [pTooltip]="item.blocked_reason"></i>
            }
          </td>
          <td>
            <patron-rt-column-title><strong>Em uso</strong></patron-rt-column-title>
            {{ sessionLabel(item) }}
          </td>
          <td class="text-end">
            <patron-rt-column-title><strong>Ações</strong></patron-rt-column-title>
            @if (canWrite) {
              <patron-button
                iconName="pi-user-minus"
                color="danger"
                variant="outline"
                [pTooltip]="'Desvincular licença'"
                (click)="askUnlink(item)">
              </patron-button>
            }
          </td>
        </tr>
      </ng-template>
    </patron-responsive-table>
  }
}

<patron-modal
  [visible]="!!confirmTarget"
  title="Desvincular licença"
  confirmButtonText="Desvincular"
  cancelButtonText="Cancelar"
  [confirmButtonLoading]="confirmLoading"
  [backdrop]="'static'"
  (confirm)="unlink()"
  (cancel)="confirmTarget = undefined"
  (visibleChanged)="$event || (confirmTarget = undefined)">
  @if (confirmTarget) {
    <p>
      Desvincular a licença de <strong>{{ systemName(confirmTarget) }}</strong> (assento
      {{ confirmTarget.number }}) de <strong>{{ userName || 'este usuário' }}</strong
      >?
    </p>
    <div class="alert alert-warning mb-0">
      A sessão dele nesse sistema é encerrada junto, e o assento volta a ficar livre.
    </div>
  }
</patron-modal>
